import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useRADActions } from "./useRADActions.js";

export const useRADSync = () => {
  const { radId } = useParams();
  const navigate = useNavigate();
  const {
    getRAD,
    handleUpdateRAD,
    handleNewRAD,
    handleDeleteRAD,
    handleDeleteAllRADs,
  } = useRADActions();

  const [currentRAD, setCurrentRAD] = useState(null);
  const lastVersion = useRef();
  const prevRadId = useRef();

  // Load RAD from model on route change
  useEffect(() => {
    if (prevRadId.current === radId) {
      return;
    }

    prevRadId.current = radId;

    if (!radId) {
      lastVersion.current = null;
      setCurrentRAD(null);
      return;
    }

    const rad = getRAD(radId);
    if (rad) {
      lastVersion.current = rad.version;
      setCurrentRAD(rad);
      return;
    }

    // Invalid/stale route param: clear active RAD once and avoid sync churn.
    lastVersion.current = null;
    setCurrentRAD(null);
  }, [radId, getRAD]);

  // Sync currentRAD to model when version bumps
  useEffect(() => {
    if (currentRAD?.id && currentRAD.version !== lastVersion.current) {
      lastVersion.current = currentRAD.version;
      handleUpdateRAD(currentRAD);
    }
  }, [currentRAD, handleUpdateRAD]);

  return {
    currentRAD,
    setCurrentRAD,
    handleNewRAD: () => handleNewRAD({ onNavigate: navigate }),
    handleDeleteRAD: (id) => {
      handleDeleteRAD(id);
      if (id === currentRAD?.id) {
        setCurrentRAD(null);
        navigate("/rad");
      }
    },
    handleDeleteAllRADs,
  };
};
